/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import { GlobalStatus } from "../../util/utils";
import { QueryData, ResponseData } from "../services/network/NetworkTypes";

export enum InvitationType {
  email = "email",
  push_notification = "push_notification",
}

export type InvitationTypeProp = {
  type: string;
  status: string;
  email_template_type: string;
};
export default class Invitation {
  constructor(
    public id: string,
    public email: string,
    public status: GlobalStatus,
    public integrationConfiguration: string,
    public createdOn: Date,
    public modifiedOn: Date,
    public invitationTypes?: Array<InvitationType>,
    public organizationUserUid?: string,
    public invitations?: Array<InvitationTypeProp>
  ) {}

  static fromJSON(json: Record<string, any>): Invitation {
    /*
      {
            "id": "624594a6-fefd-455f-9d2f-143ddcf5a311",
            "created": "2025-01-24T13:59:36.438269Z",
            "modified": "2025-01-24T13:59:36.438269Z",
            "email": "garciasi@unicc.org",
            "integration_configuration": "ee427c5e-e784-40d1-9483-e6cb27c7a39e",
            "auth_session": null
       }
 * */

    return new Invitation(
      json.id,
      json.email,
      json.status,
      json.integration_configuration,
      json.created,
      json.modified,
      json.invitation_types,
      json.organization_user_uid,
      json.invitations
    );
  }

  toJSON(): InvitationUpdateData {
    return {
      email: this.email,
    };
  }
}

export type InvitationCreateData = {
  email: string;
  integration_configuration?: string;
  invitation_types?: Array<InvitationType>;
  organization_user_uid?: string;
};

export type InvitationUpdateData = Partial<InvitationCreateData>;
// & {
//   id: string;
// };

export type InvitationDataFilter =
  | "search"
  | "email"
  | "integration_configuration"
  | "status";

// Backend keys you can sort with
export type InvitationDataOrder =
  | "email"
  | "invitations"
  | "organization_user_uid"
  | "status"
  | "created";

// This will help transform the sorting from local to backend keys.
export const invitationDataOrderTransform: Record<string, InvitationDataOrder> =
  {
    email: "email",
    created: "created",
    invitations: "invitations",
    organizationUserUid: "organization_user_uid",
    status: "status",
    createdOn: "created",
  };

// These are the keys used for table listings
export type InvitationDataTableFields =
  keyof typeof invitationDataOrderTransform;

export type InvitationQueryData = QueryData<
  InvitationDataFilter,
  InvitationDataOrder
>;

export type InvitationResponseData = ResponseData<
  Invitation,
  InvitationDataFilter,
  InvitationDataOrder
>;
